import { Component } from '@angular/core';

import { SedsButtonTypeOptions } from '../../seds-buttons/enums/seds-button-type-options.enum';
import { SedsSquareButtonAbstractComponent } from '../../seds-buttons/seds-square-button-abstract';

@Component({
    selector: 'seds-outlined-button',
    templateUrl: './seds-outlined-button.component.html',
    styleUrls: ['./seds-outlined-button.component.scss'],
    standalone: false
})
export class SedsOutlinedButtonComponent extends SedsSquareButtonAbstractComponent {
  colors: any = {
    primary: 'primary-outlined-button',
    accent: 'accent-outlined-button',
    secondary: 'secondary-outlined-button',
    tertiary: 'tertiary-outlined-button',
  };

  override type = SedsButtonTypeOptions.OUTLINED;
}
